import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import FunctionsData from "../../../Functions/FunctionsData";

export default function StaffVoucherCancelMultiple({
  open,
  setOpen,
  vouchers, // an array of voucher IDs (voucher_id)
  setLoadingVouchers,
  setSelectedVouchers,
  setSelectAll,
}) {
  const [accept, setAccept] = React.useState(false);
  const [email, setEmail] = React.useState(false);
  const [reason, setReason] = React.useState("");
  

  async function addVouchers(vouchers) {
    // setBtnAddDisabled(true)    
    FunctionsData.postData(
        FunctionsData.getApiUrl('/api/campaign/vouchers/addWithCampaigns'),
        {
            voucherId: vouchers.join(",")           
        }
    )
        .then((r) => {         
           setSelectedVouchers([]);
           setSelectAll(false);
        })
}

  function removeRedemptions() {
    // Post the array of voucher IDs and the cancellation reason to the API endpoint.
    FunctionsData.postData(
      FunctionsData.getApiUrl("/api/voucher/cancelVouchers"),
      { voucher_ids: vouchers,email, reason }
    )
      .then((data) => {
        console.log(data);
        setLoadingVouchers(true);
        setOpen(false);
        addVouchers(vouchers);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Cancel Multiple Vouchers</DialogTitle>
      <DialogContent>
        <div style={{ padding: "0 20px" }}>
          <p>You are about to cancel {vouchers.length} vouchers.</p>
          <ul>
            {vouchers.map((id, index) => (
              <li key={index}>Voucher ID: {id}</li>
            ))}
          </ul>
        </div>
        <div style={{ marginTop: 20 }}>
          <FormControl fullWidth>
            <InputLabel id="reason-select-label">Reason</InputLabel>
            <Select
              labelId="reason-select-label"
              id="reason-select"
              value={reason}
              label="Reason"
              onChange={(e) => setReason(e.target.value)}
            >
              <MenuItem value="Deceased">Deceased</MenuItem>
              <MenuItem value="Rescue">Rescue</MenuItem>
              <MenuItem value="Not needed">Not needed</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div style={{ marginTop: 20 }}>
          <input
            type="checkbox"
            onChange={(e) => setAccept(e.target.checked)}
          />{" "}
          I understand that this action cannot be undone.
        </div>
        <div style={{ marginTop: 20 }}>
          <input
            type="checkbox"
            onChange={(e) => setEmail(e.target.checked)}
          />{" "}
          Notify Owner via email.
        </div>
       
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!accept || reason === ""}
          onClick={removeRedemptions}
        >
          Remove Vouchers
        </Button>
      </DialogActions>
    </Dialog>
  );
}
